import React, { useEffect, useState, useRef, FunctionComponent } from "react";
import styles from "./AddUsers.module.css";
import TextInput from "../../Components/TextInput/TextInput";
import { FaUser } from "react-icons/fa";
import Dropdown from "../../Components/DropDown/Dropdown";
import AddModal from "../../Components/Modals/AddModal/AddModal";
import { aphabetValidator, emailValidate ,contactValidator, empIdValidator, userContactValidator} from "../../Values/validatorsnew";
import { connect, useDispatch } from "react-redux";
import {
  updateTeams,
  updateDesignations,
  createUser,
} from "../../Services/organizations";
import Loading from "../../Components/Loading/Loading";
import { showSnackbarAction } from "../../Redux/actions";
import { AiOutlineClose } from "react-icons/ai";
import {
  updateTeamsAction,
  updateDesignationsAction,
} from "../../Redux/actions";
import { useLocation } from "react-router-dom";
import { EditUserDetails, EditUserDetailsMongo, createUserMongo,googleAnalytics, SendOtpBeforeUpdatingUserMobile,VerifyOtpBeforeUpdatingUserMobile, fetchAgentDetailsFromMB } from "../../Services/users";
import { getFilterBranch } from "../../Values/utils";
import {themeColors} from "../../Components/theme";
import Label from "../../Components/Label";
import UserMobileUpdateOTPModal from "../../Components/Modals/UserMobileUpdateOTPModal/UserMobileUpdateOTPModal";

type props = {
  user: any;
  history: any;
  organization: any;
  organizationId: string;
  organizationUsers: any[];
  branchList: any[];
  theme: any;
  authToken: any;
  constants: any;
};

const AddUsers: FunctionComponent<props> = ({
  user,
  history,
  organization,
  organizationId,
  organizationUsers,
  branchList,
  theme,
  authToken,
  constants
}) => {
  const location: any = useLocation();
  // console.log("usertestByMe",location.state.detail)

  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const numberRef: any = useRef();
  const emaileRef: any = useRef();
  const branchRef: any = useRef();
  const oldMobileOtpRef: any = useRef();
  const newMobileOtpRef: any = useRef();
  const [teamSelected, setTeamSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [designationSelected, setDesignationSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [reportingTo, setReportingTo] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [profileSelected, setProfileSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });
  const [brancheSelected, setBranchSelected] = useState<any>({
    label: "Select",
    value: "Select",
  });

  const [teams, setTeams] = useState<any[]>([]);
  const [branches, setBranches] = useState<any[]>([]);
  const [designations, setDesignations] = useState<any[]>([]);
  const [userTeams, setUserTeams] = useState<any[]>([]);
  const [userDesignations, setUserDesignations] = useState<any[]>([]);
  const [profile, setProfile] = useState<string[]>([]);
  const [reporting, setReporting] = useState<any>({
    label: "",
    value: "",
  });

  const [load, setLoad] = useState(false);
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [showDesigModal, setShowDesigModal] = useState(false);
  const [showUserMobileUpdateOTPModal, setShowUserMobileUpdateOTPModal] = useState(false);
  const [reportingToProfile, setReportingToProfile] = useState<any>({
    label: "",
    value: "",
  });
  const dispatcher = useDispatch();
  const [groupHeadName, setGroupHeadName] = useState<any>({
    label: "Select",
    value: "Select",
  });   
  const EmployeeIDRef: any = useRef();
  // const [oldMobileOtp, setOldMobileOtp] = useState('');
  // const [newMobileOtp, setNewMobileOtp] = useState('');
  const [rfnum, setrfnum] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);
  const [agentDetailsMB, setAgentDetailsMB]: any = useState({});

  useEffect(() => {
    if (location?.state?.detail?.user_oid) {
      fetchAgentDetailsFromMB(setAgentDetailsMB, location.state.detail.user_oid);
    }
  }, [location.state])

  useEffect(()=>{
    let teamList:any = [];
    let designationList:any = [];
    if(organizationUsers){
      organizationUsers.map(item => {
        if(item.team){
          teamList.push(item.team);
        }
        if(item.designation){
          designationList.push(item.designation);
        }
      })
    }
    setUserTeams(teamList);
    setUserDesignations(designationList);
  },[organizationUsers])

  useEffect(() => {
    let allTeams = [...userTeams,...organization.teams];
    let allDesignations = [...userDesignations,...organization.designations];
    let uniqueTeams = Array.from(new Set(allTeams));
    let uniqueDesignations = Array.from(new Set(allDesignations));
    setTeams(uniqueTeams);
    setDesignations(uniqueDesignations);
    setBranches(branchList);
    let profiles:string[] = constants.profiles ? Object.values(constants.profiles) : [];
    setProfile(profiles);

    // const unSubProfile = fetchProfilesData((data: string[]) =>
    //   setProfile(data)
    // );

    // return () => {
    //   unSubProfile();
    // };
    // eslint-disable-next-line
  }, [organization,userTeams,userDesignations]);

  useEffect(() => {
    if (location.state !== undefined) {
      setDesignationSelected({
        label: location.state.detail.designation,
        value: location.state.detail.designation,
      });
      setProfileSelected({
        label: location.state.detail.profile,
        value: location.state.detail.profile,
      });
      setGroupHeadName({
        label: location.state.detail.group_head_name,
        value: location.state.detail.group_head_name,
      });
      setTeamSelected({
        label: location.state.detail.team,
        value: location.state.detail.team,
      });
      setReportingTo({
        label: location.state.detail.reporting_to,
        value: location.state.detail.reporting_to,
      });
      setBranchSelected({
        label: location.state.detail.branch,
        value: location.state.detail.branch,
      });
    }
    // eslint-disable-next-line
  }, [designations, profile]);

  useEffect(() => {
    let data: any = [{}];
    let items: any = [{}];
    let status: any = [{}];
    if (organizationUsers) {
      organizationUsers.forEach((item: any, index: number) => {
        // console.log("itemitemitem",item)
       if(item.status==="ACTIVE"){

        data.push({
          label: `${item.user_first_name} ${item.user_last_name} (${item.user_email})`,
          value: item.user_email,
        });
        items.push({
          label: item.profile,
          value: item.user_email,
        });
       }
      });
      setReporting(data);
      setReportingToProfile(items);
    }
  }, [organizationUsers]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
  }, []);

  // function validateEmployeeId(employeeId:any) {
  //   const pattern = /^[A-Z]{4,4}_\d{4,4}$/;
  //   return pattern.test(employeeId);
  // }

  const handleCheck = () => {
    if (firstNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter First Name!!", "error"));
      return false;
    } else if (lastNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter Last Name!!", "error"));
      return false;
    } else if (numberRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter Phone Number!!", "error"));
      return false;
    } else if (emaileRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter Email!!", "error"));
      return false;
    } else if (
      teamSelected.label === "Select" ||
      teamSelected.label === "+ New Team"
    ) {
      dispatcher(showSnackbarAction("Select Team!!", "error"));
      return false;
    } else if (
      designationSelected.label === "Select" ||
      designationSelected.label === "+ New Designation"
    ) {
      dispatcher(showSnackbarAction("Select Designation!!", "error"));
      return false;
    } else if (profileSelected.label === "Select") {
      dispatcher(showSnackbarAction("Select Profile!!", "error"));
      return false;
    } else if (reporting.length === 0) {
      return true;
    } else if (reportingTo.value === "Select") {
      dispatcher(showSnackbarAction("Select Reporting to!!", "error"));
      return false;
    } else if (
      brancheSelected.label === "Select" ||
      brancheSelected.label === "+ New Branch"
    ) {
      dispatcher(showSnackbarAction("Enter Branch!!", "error"));
      return false;
    } 
    else if(firstNameRef.current.value !== "" && aphabetValidator(firstNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("Accepts only alphabet or alphanumeric combination In Name", "error"));
      return false;
    }
    else if(lastNameRef.current.value !== "" && aphabetValidator(lastNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("No special character allowed in last name", "error"));
      return false;
    }
    else if(emaileRef.current.value !== "" && emailValidate(emaileRef.current.value) === "Invalid Email"){
      dispatcher(
        showSnackbarAction("Invalid Email!!", "error")
      );
      return false;
    }
    else if(emaileRef.current.value == reportingTo.value){
      dispatcher(
        showSnackbarAction("User cannot report to itself", "error")
      );
      return false;
    }else if(EmployeeIDRef.current.value !== "" && empIdValidator(EmployeeIDRef.current.value) === "Invalid Format Ex- EMP-"){
      dispatcher(showSnackbarAction("Invalid Employee ID (EMP-1234 or EMP_1234)", "error"));
      return false;
    }
    // else if (EmployeeIDRef.current.value === "") {
    //   // validateEmployeeId(EmployeeIDRef.current.value)
    //   dispatcher(showSnackbarAction("Enter Employee ID!!", "error"));
    //   return false;
    // }else if (EmployeeIDRef.current.value) {
    //   const pattern = /^[A-Z]{4,4}_\d{4,4}$/;
    //   dispatcher(showSnackbarAction("Employee ID should be in this (ABCD_0000) format!!", "error"));
    //   return pattern.test(EmployeeIDRef.current.value);
    // }
    else {
      return true;
    }
  };

  const create = (e:any) => {
    e.preventDefault();
    const val = handleCheck();
    let activeUsers = organizationUsers.filter(
      (item) => item.status === "ACTIVE"
    );
    const reporting_to = reporting.length === 0 ? "" : reportingTo.value;
    if (val) {
      if (!profile.includes(profileSelected.value)) {
        dispatcher(showSnackbarAction("Invalid Profile!!", "error"));
      } else {
        setLoad(true);
        // createUser(
        //   emaileRef.current.value.trim(),
        //   firstNameRef.current.value.trim(),
        //   lastNameRef.current.value.trim(),
        //   teamSelected.label,
        //   reporting_to,
        //   numberRef.current.value.trim(),
        //   designationSelected.label,
        //   brancheSelected.label === "Select" ||
        //     brancheSelected.label === "+ New Branch"
        //     ? ""
        //     : brancheSelected.value,
        //   activeUsers.length < Number(organization.no_of_employees)
        //     ? "ACTIVE"
        //     : "INACTIVE",
        //   profileSelected.value,
        //   dispatcher,
        //   history,
        //   organizationId,
        //   organization.admin_first_name + " " + organization.admin_last_name,
        //   organization.country,
        //   organization.state,
        //   false,
        //   (data: boolean) => setLoad(data),
        //   reportingToProfile,
        //   groupHeadName.value,
        //   EmployeeIDRef.current.value,
        //   authToken
        // );
        createUserMongo(
          emaileRef.current.value.trim(),
          firstNameRef.current.value.trim(),
          lastNameRef.current.value.trim(),
          teamSelected.label,
          reporting_to,
          numberRef.current.value.trim(),
          designationSelected.label,
          brancheSelected.label === "Select" ||
            brancheSelected.label === "+ New Branch"
            ? ""
            : brancheSelected.value,
          activeUsers.length < Number(organization.no_of_employees)
            ? "ACTIVE"
            : "INACTIVE",
          profileSelected.value,
          dispatcher,
          history,
          organizationId,
          organization.admin_first_name + " " + organization.admin_last_name,
          organization.country,
          organization.state,
          false,
          (data: boolean) => setLoad(data),
          reportingToProfile,
          groupHeadName.value,
          EmployeeIDRef.current.value,
          authToken,
          organization.oid
        );
      }
    }
  };

  const EditCheck = () => {
    if (firstNameRef.current.value === "") {
      firstNameRef.current.value = location.state.detail.user_first_name;
    }
    if (lastNameRef.current.value === "") {
      lastNameRef.current.value = location.state.detail.user_last_name;
    }
    // if (numberRef.current.value === "") {
    //   numberRef.current.value = location.state.detail.contact_no;
    // }
    if (
      designationSelected.label === "Select" ||
      teamSelected.label === "+ New Designation"
    ) {
      designationSelected.label = location.state.detail.designation;
    }
    if (profileSelected.label === "Select") {
      profileSelected.label = location.state.detail.profile;
    }
    if (reportingTo.value === "Select") {
      reportingTo.value = location.state.detail.reporting_to;
    }
    if (
      teamSelected.label === "Select" ||
      teamSelected.label === "+ New Team"
    ) {
      teamSelected.label = location.state.detail.team;
    }
    if (groupHeadName.value === "Select") {
      groupHeadName.value = location.state.detail.groupHeadName;
    }
    if(firstNameRef.current.value !== "" && aphabetValidator(firstNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("Accepts only alphabet or alphanumeric combination In Name", "error"));
      return false;
    }
    if(lastNameRef.current.value !== "" && aphabetValidator(lastNameRef.current.value) === "Invalid Name"){
      dispatcher(showSnackbarAction("No special character allowed in last name", "error"));
      return false;
    }
    if(emaileRef.current.value !== "" && emailValidate(emaileRef.current.value) === "Invalid Email"){
      dispatcher(
        showSnackbarAction("Invalid Email!!", "error")
      );
      return false;
    }
    if(emaileRef.current.value == reportingTo.value && profileSelected.value !== "Admin"){
      dispatcher(
        showSnackbarAction("User cannot report to itself", "error")
      );
      return false;
    }
    if(EmployeeIDRef.current.value !== "" && empIdValidator(EmployeeIDRef.current.value) === "Invalid Format Ex- EMP-"){
      dispatcher(showSnackbarAction("Invalid Employee ID (EMP-1234 or EMP_1234)", "error"));
      return false;
    }
    if (numberRef.current.value === "" || contactValidator(numberRef.current.value) == "Invalid Phone No.") {
      dispatcher(showSnackbarAction("Please enter a valid number", "error"));
      return false;
    }
    // if (EmployeeIDRef.current.value === "") {
    //   // validateEmployeeId(EmployeeIDRef.current.value)
    //   dispatcher(showSnackbarAction("Enter Employee ID!!", "error"));
    //   return false;
    // }
    // if (EmployeeIDRef.current.value) {
    //   const pattern = /^[A-Z]{4,4}_\d{4,4}$/;
    //   dispatcher(showSnackbarAction("Employee ID should be in this (ABCD_0000) format!!", "error"));
    //   return pattern.test(EmployeeIDRef.current.value);
    // }

    return true;
  };

  const edit = (e:any) => {
    e.preventDefault();
    setIsUpdating(true)
    const val = EditCheck();
    const reporting_to = reporting.length === 0 ? "" : reportingTo.value;
    if (val) {
      if (!profile.includes(profileSelected.value)   && profileSelected.value !== "Admin") {
        dispatcher(showSnackbarAction("Invalid Profile!!", "error"));
      } else {
        if(numberRef.current.value !== location.state.detail.contact_no && (!agentDetailsMB.mvtmobile  || (agentDetailsMB.mvtmobile != numberRef.current.value)) &&  organization.oid){
          SendOtpBeforeUpdatingUserMobile(
            location.state.detail.contact_no,
            location.state.detail.user_mb_isd ? location.state.detail.user_mb_isd : "50",
            numberRef.current.value,
            dispatcher,
            setrfnum,
            setShowUserMobileUpdateOTPModal,
            location.state.detail.profile==="Admin"?true:false,
            location.state.detail.uid,
            (data: boolean)=>setIsUpdating(data),
            EmployeeIDRef.current.value?EmployeeIDRef.current.value:"",
            location.state.detail.uid,
          )
        }else{
          setLoad(true);
          EditUserDetailsMongo(
            location.state.detail.uid,
            firstNameRef.current.value.trim(),
            lastNameRef.current.value.trim(),
            numberRef.current.value.trim(),
            designationSelected.label,
            profileSelected.value,
            reporting_to,
            teamSelected.label,
            dispatcher,
            numberRef.current.value !== location.state.detail.contact_no
              ? true
              : false,
            (data: boolean) => setLoad(data),
            history,
            reportingToProfile,
            brancheSelected.label === "Select" ||
              brancheSelected.label === "+ New Branch" || 
              brancheSelected.label === undefined
              ? location.state.detail.branch
                ? location.state.detail.branch
                : ""
              : brancheSelected.label,
              authToken,
            groupHeadName.value,
            EmployeeIDRef.current.value?EmployeeIDRef.current.value:"",
            EmployeeIDRef.current.value !== location.state.detail.employee_id
            ? true
            : false,
            organizationId
          );
        }
      }
    }
  };

  const containerStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  const cardContainerStyles = {backgroundColor:theme ? themeColors.cardBackgroundColor:themeColors.cardBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  const selectInputContainerStyles = {width:"140px",marginRight:"5px"};
  const [isGACalled, setIsGACalled] = useState<any>(false);
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Admin_Add_User_Screen',user)
      }
    }
  },[user])

  // console.log("isupdate",isUpdating)
  return (
    <>
        <div className={styles.parent} style={containerStyles}>
        {organizationUsers === undefined && <Loading />}
        {load && <Loading />}
        <div 
        // className={styles.headerView}
         className="d-flex flex-row w-100 px-4 pt-4"
        >
            <h5 
            // className={styles.heading}
            >
              {location.state !== undefined
                ? "Edit User Details"
                : "Add User Details"}
            </h5>
            <AiOutlineClose
              className={styles.closeIcon}
              size={25}
              onClick={() => history.replace("/")}
            />
          </div>
        <div 
        // className={styles.child}
         className="w-100 d-flex flex-column gap-2 px-4"
        >
                 <form className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>
                 <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="First Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={firstNameRef}
                  disabled={isUpdating}
                  value={
                    location.state ? location.state.detail.user_first_name : ""
                  }
                  type="text"
                  validator={aphabetValidator}
                >
                  <FaUser color={"#808080"} />
                </TextInput>
              </div>
            </div>

            <div className={styles.divide}>
            <Label label="Last Name" required={location.state !== undefined ? false:true} />
              <div className={styles.inputContainer}>
                {location.state !== undefined ?<TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={lastNameRef}
                  disabled={isUpdating}
                  value={
                    location.state ? location.state.detail.user_last_name : ""
                  }
                  // validator={ aphabetValidator}
                >
                  <FaUser color={"#808080"} />
                  </TextInput>:<TextInput
                title={""}
                style={{ backgroundColor: "#fff" }}
                ref={lastNameRef}
                disabled={isUpdating}
                value={
                  location.state ? location.state.detail.user_last_name : ""
                }
                validator={ aphabetValidator}
              >
                <FaUser color={"#808080"} />
                </TextInput>}
                  
              </div>
            </div>
            <div className={styles.divide}>
            <Label label="Mobile Number" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={numberRef}
                  disabled={isUpdating}
                  minValue={'0'}
                  value={location.state ? location.state.detail.contact_no : ""}
                  validator={userContactValidator}
                  type="text"
                  length={true}
                  inputPattern={/^[0-9]{0,10}$/}
                />
              </div>
            </div>

          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
               <Label label="Email Id" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={""}
                  style={
                    location.state !== undefined
                      ? { backgroundColor: "#f5f5f5" }
                      : { backgroundColor: "#fff" }
                  }
                  validator={emailValidate}
                  ref={emaileRef}
                  disabled={location.state !== undefined ? true : isUpdating}
                  value={location.state ? location.state.detail.user_email : ""}
                />
              </div>
            </div>
            <div className={styles.divide}>
            <Label label="Team" required={location.state !== undefined ? false:true} />
              <div style={{...selectInputContainerStyles}}>
                <Dropdown
                  title={" + New Team"}
                  option={teams}
                  setDetails={() => setShowTeamModal(true)}
                  selectedValue={teamSelected}
                  setSelectedValue={(value) => {
                    setTeamSelected(value);
                  }}
                  disable={isUpdating}
                />
              </div>
            </div>

            <div className={styles.divide}>
            <Label label="Reporting To" required={true} />
              <div style={{...selectInputContainerStyles}}>
                <Dropdown
                  choices={reporting}
                  selectedValue={reportingTo}
                  setSelectedValue={(value) => setReportingTo(value)}
                  disable={isUpdating}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
            <Label label="Designation" required={true} />
              <div style={{...selectInputContainerStyles}}>
                <Dropdown
                  title={" + New Designation"}
                  option={designations}
                  setDetails={() => setShowDesigModal(true)}
                  selectedValue={designationSelected}
                  setSelectedValue={(value) => setDesignationSelected(value)}
                  disable={isUpdating}
                />
              </div>
            </div>
            <div className={styles.divide}>
            <Label label="Profile" required={true} />
              <div style={{...selectInputContainerStyles}}>
                <Dropdown
                  option={profile}
                  selectedValue={profileSelected}
                  setSelectedValue={(value) => setProfileSelected(value)}
                  disable={profileSelected.value === "Admin"?true:isUpdating}
                />
              </div>
            </div>
            <div className={styles.divide}>
            <Label label="Branch" required={location.state !== undefined ? false:true} />
              <div>
                <div style={{...selectInputContainerStyles}}>
                  <Dropdown
                    title={" + New Branch"}
                    option={branches}
                    setDetails={() => setShowBranchModal(true)}
                    selectedValue={brancheSelected}
                    setSelectedValue={(value) => {
                      setBranchSelected(value);
                    }}
                    disable={isUpdating}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.box2}>
          {/* <div className={styles.divide}>
            <Label label="Group Head Name" required={false} />
              <div style={{...selectInputContainerStyles}}>
                <Dropdown
                  choices={reporting}
                  selectedValue={groupHeadName}
                  setSelectedValue={(value) => setGroupHeadName(value)}
                  // disable={false}
                />
              </div>
            </div> */}
            <div className={styles.divide}>
            <Label label="Employee ID" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"EMP-1234 or EMP_1234"}
                  style={{ backgroundColor: "#fff" }}
                  ref={EmployeeIDRef}
                  // disabled={location.state ? location.state.detail.employee_id : false}
                  // disabled={location.state  ? true : false}
                  value={
                    location.state ? location.state.detail.employee_id : ""
                  }
                >
                  <FaUser color={"#808080"} />
                </TextInput>
              </div>
            </div>
              {location.state !== undefined && (
                <div className={styles.divide}>
                  <Label label="MB OID Mapped" required={false} />
                  <div className={styles.inputContainer}>
                    <TextInput
                      title={"MB OID Mapped"}
                      style={{ backgroundColor: "#fff" }}
                      // ref={EmployeeIDRef}
                      // disabled={location.state ? location.state.detail.employee_id : false}
                      disabled={true}
                      value={
                        location.state ? location.state.detail.mb_oid_mapped : "No"
                      }
                    >
                      {/* <FaUser color={"#808080"} /> */}
                    </TextInput>
                  </div>
                </div>
              )}
            <div className={styles.divide}>
            {/* <Label label="Last Name" required={true} /> */}
              <div className={styles.inputContainer}>
                {/* <TextInput
                  title={""}
                  style={{ backgroundColor: "#fff" }}
                  ref={lastNameRef}
                  disabled={false}
                  value={
                    location.state ? location.state.detail.user_last_name : ""
                  }
                >
                  <FaUser color={"#808080"} />
                </TextInput> */}
              </div>
            </div>
            </div>

          {location.state !== undefined ? (
            <button className={styles.button} onClick={(e:any) => edit(e)} disabled={isUpdating}>
              Update
            </button>
          ) : (
            <button className={styles.button} onClick={(e:any) => create(e)}>
              Submit
            </button>
          )}
                 </form>
        </div>
      </div>

      {showTeamModal && (
        <>
          <AddModal
            show={showTeamModal}
            heading={"Create Team"}
            subHeading={"Enter Name"}
            close={() => setShowTeamModal(false)}
            onSave={(value: string) => {
              updateTeams(
                value,
                setLoad,
                organizationId,
                (data: boolean) => {
                  dispatcher(updateTeamsAction(value));
                  setShowTeamModal(data);
                  setTeamSelected({ label: value, value });
                },
                dispatcher
              );
            }}
          />
        </>
      )}
      {showBranchModal && (
        <>
          <AddModal
            show={showBranchModal}
            heading={"Create Branch"}
            subHeading={"Enter Name"}
            close={() => setShowBranchModal(false)}
            onSave={(value: string) => {
              setBranchSelected({ label: value, value });
              setShowBranchModal(false);
            }}
          />
        </>
      )}
      {showDesigModal && (
        <>
          <AddModal
            show={showDesigModal}
            heading={"Create Designation"}
            subHeading={"Enter designation"}
            close={() => setShowDesigModal(false)}
            onSave={(value) => {
              updateTeams(
                value,
                setLoad,
                organizationId,
                (data: boolean) => {
                  dispatcher(updateDesignationsAction(value));
                  setShowDesigModal(data);
                  setDesignationSelected({ label: value, value });
                },
                dispatcher
              );
            }}
          />
        </>
      )}
      {
        showUserMobileUpdateOTPModal && (
          <UserMobileUpdateOTPModal
            open={showUserMobileUpdateOTPModal}
            close={() => setShowUserMobileUpdateOTPModal(false)} 
            oldMobileNumber={location.state.detail.contact_no}
            newMobileNumber={numberRef.current.value}
            oldMobileOtp={oldMobileOtpRef}
            newMobileOtp={newMobileOtpRef}
            // setOldMobileOtp={setOldMobileOtp}
            // setNewMobileOtp={setNewMobileOtp}
            onVerify={()=>{
              // console.log("onverify",rfnum,location.state.detail.contact_no,)
              VerifyOtpBeforeUpdatingUserMobile(
                // rfnum,
                rfnum,
                location.state.detail.contact_no,
                location.state.detail.user_mb_isd ? location.state.detail.user_mb_isd : "50",
                location.state.detail.profile==="Admin"?oldMobileOtpRef.current.value:"0" ,
                numberRef.current.value,
                newMobileOtpRef.current.value,
                location.state.detail.uid,
                firstNameRef.current.value.trim(),
                lastNameRef.current.value.trim(),
                numberRef.current.value.trim(),
                designationSelected.label,
                profileSelected.value,
                reporting.length === 0 ? "" : reportingTo.value,
                teamSelected.label,
                dispatcher,
                numberRef.current.value !== location.state.detail.contact_no
                  ? true
                  : false,
                (data: boolean) => setLoad(data),
                history,
                reportingToProfile,
                brancheSelected.label === "Select" ||
                  brancheSelected.label === "+ New Branch" || 
                  brancheSelected.label === undefined
                  ? location.state.detail.branch
                    ? location.state.detail.branch
                    : ""
                  : brancheSelected.label,
                  authToken,
                  (data: boolean)=>setIsUpdating(data),
                groupHeadName.value,
                EmployeeIDRef.current.value?EmployeeIDRef.current.value:"",
                EmployeeIDRef.current.value !== location.state.detail.employee_id
                ? true
                : false,
                organizationId,
                location.state.detail.profile==="Admin"?true:false,
                location.state.detail.user_oid
              );
            }}
            updateUserDetail={location.state.detail}
            isUpdate={()=>setIsUpdating(false)}
          />
        )
      }
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organization: state.organization,
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    branchList: state.branchList.data,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    constants:state.constants.data,
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(AddUsers);